/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["textarea.invalid[_ngcontent-%COMP%]{background-color:#f8d7da!important;border-color:#f5c6cb!important}.ips-gray-white-bg[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
